export enum APPOINTMENT_EVENT_TYPE {
  APPOINTMENT = 'APPOINTMENT',
  STORE_CLOSED = 'STORE_CLOSED',
}
